import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import AboutScreen from "./screens/AboutScreen";
import LegalMentionsScreen from "./screens/LegalMentionsScreen";
import ErrorScreen from "./screens/ErrorScreen";
import MetaLayoutScreen from "./screens/meta/MetaLayoutScreen";
import HomeScreen from "./screens/HomeScreen";
import {internalRoutes} from "./constants/internalRoutes";
import PreviewScreen from "./screens/PreviewScreen";
import ThemesScreen from "./screens/ThemesScreen";
import GamesScreen from "./screens/games/GamesScreen";
import MultiplicationGameScreen from "./screens/games/MultiplicationGameScreen";
import RelativeSumGameScreen from "./screens/games/RelativeSumGameScreen";
import * as Sentry from "@sentry/react";
import {Environment} from "./enums/Environment";
import AuthenticationScreen from "./screens/AuthenticationScreen";
import {Provider} from "react-redux";
import store from "./store";
import MetaCoursesScreen from "./screens/courses/MetaCoursesScreen";
import GlossaryScreen from "./screens/glossary/GlossaryScreen";
import LegalPrivacyScreen from "./screens/LegalPrivacyScreen";
import SupportProjectScreen from "./screens/SupportProjectScreen";

// Router
const router = createBrowserRouter([
    {
        path: internalRoutes.home,
        element: <MetaLayoutScreen/>,
        errorElement: <ErrorScreen />,
        children: [
            // ---- Authentication
            { path: internalRoutes.authentication, element: <AuthenticationScreen /> },
            // ---- Main navigation
            { path: internalRoutes.home, element: <HomeScreen /> },
            { path: internalRoutes.courses, element: <MetaCoursesScreen /> },
            { path: internalRoutes.games, element: <GamesScreen />},
            { path: internalRoutes.glossary, element: <GlossaryScreen />},
            // ---- ---- Games
            {path: internalRoutes.multiplicationGame, element: <MultiplicationGameScreen />},
            {path: internalRoutes.relativeSumGame, element: <RelativeSumGameScreen />},
            // ---- Side navigation
            { path: internalRoutes.about, element: <AboutScreen /> },
            { path: internalRoutes.support, element: <SupportProjectScreen /> },
            { path: internalRoutes.themes, element: <ThemesScreen /> },
            { path: internalRoutes.legals, element: <LegalMentionsScreen /> },
            { path: internalRoutes.privacy, element: <LegalPrivacyScreen /> },
        ],
    },
    {
        path: internalRoutes.previewQuestion,
        element: <PreviewScreen isQuestion = {true} />
    },
    {
        path: internalRoutes.previewExerciser,
        element: <PreviewScreen isQuestion = {false} />
    }
], {
    future: {
        v7_relativeSplatPath: true, // Enables relative paths in nested routes
        v7_fetcherPersist: true,   // Retains fetcher state during navigation
        v7_normalizeFormMethod: true, // Normalizes form methods (e.g., POST or GET)
        v7_partialHydration: true, // Supports partial hydration for server-side rendering
        v7_skipActionErrorRevalidation: true, // Prevents revalidation when action errors occur
    },
});

// Init Sentry
const env = process.env.REACT_APP_ENV
if (env !== "" && env !== Environment.FAKER) {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN || "",
        environment: process.env.REACT_APP_ENV || "",
        integrations: [],
        beforeSend(event) {
            // Cancel errors excepts the one manually sent
            if (!event.message) {
                return null;
            }
            return event;
        },
    });
}

// DOM
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Provider store={store}>
          <RouterProvider future={{ v7_startTransition: true }}
                          router={router} />
      </Provider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
